

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","d":"M11 .25C16.93.25 21.75 5.07 21.75 11S16.93 21.75 11 21.75.25 16.93.25 11 5.07.25 11 .25Zm0 1.5C5.9 1.75 1.75 5.9 1.75 11S5.9 20.25 11 20.25s9.25-4.15 9.25-9.25S16.1 1.75 11 1.75Zm4.78 5.88c.29.29.29.77 0 1.06l-5.67 5.67a.75.75 0 0 1-1.06 0l-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 5.14-5.14c.29-.29.77-.29 1.06 0Z"}, []), "\n"]);
};

        